import React from "react";
import InTaxBaseComponent from "../bases/InTaxBaseComponent/InTaxBaseComponent";
export default function IncomeTaxForecastPage() {
    return <div>
        <InTaxBaseComponent/>
    </div>;
}
